import React from 'react';

export const FormSkeleton: React.FC = () => (
  <div className="min-h-screen bg-slate-50 dark:bg-slate-950 py-8 px-4">
    <div className="w-full max-w-3xl mx-auto bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl shadow-sm min-h-screen p-4 sm:p-6 lg:p-8 animate-pulse">
      <div className="w-full h-64 bg-slate-100 dark:bg-slate-800 rounded-xl mb-6"></div>
      <div className="h-8 bg-slate-100 dark:bg-slate-800 rounded-md w-3/4 mb-4"></div>
      <div className="space-y-3 mb-6">
        <div className="h-4 bg-slate-100 dark:bg-slate-800 rounded-md w-full"></div>
        <div className="h-4 bg-slate-100 dark:bg-slate-800 rounded-md w-5/6"></div>
      </div>
      <div className="mb-8">
        <div className="h-5 bg-slate-100 dark:bg-slate-800 rounded-md w-1/4 mb-3"></div>
        <div className="h-12 bg-slate-100 dark:bg-slate-800 rounded-lg w-full"></div>
      </div>
      <div className="space-y-4 mb-8">
        <div className="h-12 bg-slate-100 dark:bg-slate-800 rounded-lg w-full"></div>
        <div className="h-12 bg-slate-100 dark:bg-slate-800 rounded-lg w-full"></div>
        <div className="h-12 bg-slate-100 dark:bg-slate-800 rounded-lg w-full"></div>
      </div>
      <div className="h-14 bg-slate-100 dark:bg-slate-800 rounded-xl w-full"></div>
    </div>
  </div>
);
